<template>
  <div class="container">
    <div class="albums">
      <aspect-ratio :w="3" :h="2" v-for="(album, idx) in sortedAlbums" :key="album.id"
                    :id="`album-tile-${album.id}`" class="album-tile-wrapper">
        <div class="album-tile" @click="$emit('open', album.id)">
          <b-skeleton-img width="100%" height="100%" v-if="loading" no-aspect/>
          <div class="missing-photo" v-else-if="!loading && !title[album.id]">
            <b-icon-exclamation-circle font-scale="5"/>
          </div>
          <div class="title-photo" v-else>
            <picture>
              <source :srcset="title[album.id].jpegSrcSet()" type="image/jpeg"/>
              <source :srcset="title[album.id].webpSrcSet()" type="image/webp"/>
              <img :src="title[album.id].defaultSrc()" type="image/jpeg" :alt="album.name"/>
            </picture>
          </div>
          <div class="title-box">
            <span class="album-title">{{ album.name }}</span><br/>
            {{ albumDates[idx] }}
          </div>
        </div>
      </aspect-ratio>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import AspectRatio from '@/components/technical/AspectRatio.vue';

export default {
  name: 'Albums',
  components: {
    AspectRatio,
  },

  props: {
    albums: {
      type: Object,
      required: true,
    },

    title: {
      type: Object,
      required: true,
    },

    loading: {
      type: Boolean,
    },
  },

  computed: {
    albumDates() {
      return this.albums.map(album => moment(album.date)
        .format('DD.MM.YYYY'));
    },

    sortedAlbums() {
      return this.albums.slice()
        .sort((a, b) => this.dateCompare(a.date, b.date));
    },
  },

  methods: {
    dateCompare(a, b) {
      if (a.getTime() < b.getTime()) {
        return -1;
      }
      if (a.getTime() > b.getTime()) {
        return 1;
      }

      return 0;
    },
  },
};
</script>

<style lang="scss">
main#gallery {
  flex: 1 0 auto;
  padding: 1.5rem;

  text-align: left;

  .albums {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    margin: auto;

    .album-tile-wrapper {
      margin: 0.75rem;
      flex: 2 1 500px;

      cursor: pointer;

      transition: transform 500ms ease;

      border: 1px solid #ccc;
      border-radius: 2px;

      &:hover {
        transform: scale(1.025);
      }
    }

    .album-tile {
      width: 100%;
      height: 100%;

      text-decoration: none !important;

      .missing-photo, .title-photo {
        width: 100%;
        height: 100%;
      }

      .missing-photo {
        display: flex;
        align-items: center;
        justify-content: center;

        line-height: 1;
        color: #aaa;
        background-color: #ccc;
      }

      .title-photo {
        picture, picture > img {
          width: 100%;
          height: auto;
        }
      }

      .title-box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;

        padding: 1rem;

        background-color: hsla(0, 0, 50%, 0.25);
        color: white;

        line-height: 1.15;

        .album-title {
          font-size: 1.6rem;
          font-weight: 500;
          font-family: "Sitka Banner", serif;
        }
      }
    }
  }
}
</style>
